import React, { useState } from "react";
import PropTypes from "prop-types";
import { Tooltip as ReactTip } from "reactstrap";

const propTypes = {
  text: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  className: PropTypes.string,
  placement: PropTypes.string,
  autohide: PropTypes.bool
};

const defaultProps = {
  className: "",
  placement: "bottom",
  autohide: true
};

function Tooltip(props) {
  const { text, target, placement, autohide, className } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      return;
    }
    setTooltipOpen(!tooltipOpen);
  };

  return (
    <ReactTip
      className={className}
      trigger="hover"
      placement={placement}
      isOpen={tooltipOpen}
      autohide={autohide}
      target={target}
      toggle={toggle}
      delay={{ show: 500, hide: 0 }}
      fade
    >
      {text}
    </ReactTip>
  );
}

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

export default Tooltip;
